import { FunctionComponent } from 'react';
import Button from '../../../shared/components/Button/Button';
import Modal from '../../../shared/components/Modal/Modal';
import Text from '../../../shared/components/Text/Text';
import useModal from '../../../shared/hooks/useModal';

interface Props {
	title: string;
	onAccept: () => void;
}

const ConfirmModal: FunctionComponent<Props> = ({ title, onAccept }) => {
	const { close } = useModal();

	const onAcceptClick = () => {
		onAccept();
		close();
	};

	return (
		<Modal.Root>
			<Modal.Content>
				<Modal.Title>{title}</Modal.Title>
				<div className="space-y-4">
					<Text>Are you sure you want to delete this?</Text>
				</div>
				<Text className="italic">
					This action is irreversible. Please proceed with caution.
				</Text>
			</Modal.Content>
			<Modal.Actions>
				<div className="flex justify-between">
					<Button variant="secondary" onClick={close}>
						Cancel
					</Button>
					<Button variant="danger" onClick={onAcceptClick}>
						Delete
					</Button>
				</div>
			</Modal.Actions>
		</Modal.Root>
	);
};

export default ConfirmModal;
